/* Horizontal Smooth Scroll Animation (Safari-safe) class scroll-stop-animation */
document.addEventListener('DOMContentLoaded', function () {
  const groups = document.querySelectorAll('.group-block.scroll-stop-animation');

  groups.forEach(group => {
    const scroller = group.querySelector('.group-block-content');
    if (!scroller) return;

    const items = scroller.querySelectorAll('.image-block');
    if (items.length <= 1) return;

    // --- CONFIG ---
    const scrollSpeed = 0.5; // px per frame (can be fractional)
    // ---------------

    // Ensure it's actually scrollable
    // (Safari won't move if overflow-x isn't scroll/auto)
    // You can remove these if you already set via CSS.
    scroller.style.overflowX = scroller.style.overflowX || 'auto';

    // Clone items (as you had)
    const cloneFirst = items[0].cloneNode(true);
    const cloneLast = items[items.length - 1].cloneNode(true);
    scroller.appendChild(cloneFirst);
    scroller.insertBefore(cloneLast, items[0]);

    // Set initial position after layout paints (more reliable)
    requestAnimationFrame(() => {
      const gap = 6; // your gap
      const itemWidth = items[0].getBoundingClientRect().width + gap;
      scroller.scrollLeft = Math.round(itemWidth);
    });

    let direction = 1;
    let animationFrameId = null;

    // ✅ Safari fix: accumulate fractional px until we have >= 1px to apply
    let carry = 0;

    const animate = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;

      // If not scrollable yet (images not loaded, widths 0, etc.), retry next frame
      if (maxScroll <= 0) {
        animationFrameId = requestAnimationFrame(animate);
        return;
      }

      carry += scrollSpeed;
      const step = Math.floor(carry); // whole pixels we can apply
      carry -= step;

      if (step > 0) {
        scroller.scrollLeft += step * direction;
      }

      // Your boundary reverse logic (kept as-is)
      if (scroller.scrollLeft >= maxScroll) {
        direction = -1;
        carry = 0;
      } else if (scroller.scrollLeft <= 0) {
        direction = 1;
        carry = 0;
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animationFrameId = requestAnimationFrame(animate);

    scroller.addEventListener('mouseenter', () => {
      cancelAnimationFrame(animationFrameId);
    });

    scroller.addEventListener('mouseleave', () => {
      animationFrameId = requestAnimationFrame(animate);
    });
  });
});
/* end */



/*----------------------
* TURN CUSTOM-CAROUSEL CLASS INTO slider
*-----------------*/

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section.custom-carousel');
  sections.forEach(initCustomCarousel);
});

function initCustomCarousel(section) {
  const wrapper = section.querySelector('.section-content-wrapper');
  if (!wrapper) return;

  // direct child group-blocks become slides
  const childGroups = Array.from(wrapper.children).filter(el =>
    el.classList.contains('group-block')
  );

  if (childGroups.length <= 1) {
    // nothing to slide
    return;
  }

  // ----- build structure: viewport -> track -> slides -----
  const viewport = document.createElement('div');
  viewport.className = 'cg-carousel-viewport';

  const track = document.createElement('div');
  track.className = 'cg-carousel-track';

  childGroups.forEach(group => {
    group.classList.add('cg-slide');
    track.appendChild(group);
  });

  viewport.appendChild(track);

  // put viewport at the top of wrapper
  wrapper.insertBefore(viewport, wrapper.firstChild);

  // ----- nav buttons -----
  const nav = document.createElement('div');
  nav.className = 'cg-carousel-nav';
  nav.innerHTML = `
    <button
      class="cg-carousel-btn cg-carousel-prev"
      type="button"
      aria-label="Previous slide"
    > <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg></button>
    <button
      class="cg-carousel-btn cg-carousel-next"
      type="button"
      aria-label="Next slide"
    ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg></button>
  `;
  wrapper.appendChild(nav);

  const prevBtn = nav.querySelector('.cg-carousel-prev');
  const nextBtn = nav.querySelector('.cg-carousel-next');

  let index = 0;
  const total = childGroups.length;

  const goTo = (i) => {
    index = (i + total) % total; // loop
    track.style.transform = `translateX(-${index * 100}%)`;
  };

  prevBtn.addEventListener('click', () => goTo(index - 1));
  nextBtn.addEventListener('click', () => goTo(index + 1));

  // ----- basic touch swipe for mobile -----
  let startX = 0;
  let isDragging = false;

  viewport.addEventListener('touchstart', (e) => {
    if (!e.touches || !e.touches.length) return;
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  viewport.addEventListener('touchend', (e) => {
    if (!isDragging || !e.changedTouches || !e.changedTouches.length) return;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (Math.abs(diff) > 50) { // swipe threshold
      if (diff < 0) {
        goTo(index + 1); // swipe left → next
      } else {
        goTo(index - 1); // swipe right → prev
      }
    }
    isDragging = false;
  }, { passive: true });

  // start on first slide
  goTo(0);
}


/*------------------ end of turning custom-carousel into SLIDER *--------------------*/


/*----------------------
* TURN CUSTOM-TABS CLASS INTO TAB
*-----------------*/

document.addEventListener('DOMContentLoaded', () => {
  const tabSections = document.querySelectorAll('.section.custom-tabs');
  tabSections.forEach(initCustomTabs);
});

function initCustomTabs(section) {
  const wrapper = section.querySelector('.section-content-wrapper');
  if (!wrapper) return;

  // Top-level group-blocks become panels
  const panels = Array.from(wrapper.children).filter(el =>
    el.classList.contains('group-block')
  );

  if (panels.length <= 1) return; // nothing to tab

  // Create nav container
  const nav = document.createElement('div');
  nav.className = 'cg-tabs-nav';
  nav.setAttribute('role', 'tablist');

  // Insert nav before the first panel
  wrapper.insertBefore(nav, panels[0]);

  const buttons = [];

  panels.forEach((panel, i) => {
    panel.classList.add('cg-tab-panel');

    // Grab the first h2 inside this panel as the label (fallback to Tab N)
    const heading = panel.querySelector('h2, h4, h5');
    const label = heading ? heading.textContent.trim() : `Tab ${i + 1}`;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cg-tab-btn';
    btn.textContent = label;

    // ARIA wiring
    const tabId = `cg-tab-${Date.now()}-${i}`;
    const panelId = `cg-panel-${Date.now()}-${i}`;
    btn.id = tabId;
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-controls', panelId);
    btn.setAttribute('aria-selected', 'false');

    panel.id = panelId;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tabId);
    panel.setAttribute('hidden', 'hidden');

    nav.appendChild(btn);
    buttons.push(btn);

    btn.addEventListener('click', () => activateTab(i, buttons, panels));
  });

  // Activate first tab by default
  activateTab(0, buttons, panels);
}

function activateTab(index, buttons, panels) {
  buttons.forEach((btn, i) => {
    const isActive = i === index;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    btn.tabIndex = isActive ? 0 : -1;
  });

  panels.forEach((panel, i) => {
    const isActive = i === index;

    if (isActive) {
      panel.classList.add('is-active');

      // Show panel first
      panel.removeAttribute('hidden');

      // Kick off a simple enter animation
      panel.classList.add('is-entering');
      requestAnimationFrame(() => {
        panel.classList.remove('is-entering');
      });
    } else {
      panel.classList.remove('is-active', 'is-entering');
      panel.setAttribute('hidden', 'hidden');
    }
  });
}



/*------------------ end of turning custom-TABS into tabs *--------------------*/



/*----------------------
* READ THE VALUE OF HEADER-COMPONENT TO USE IN CSS VARIABLES
*-----------------*/
(function () {
  const CSS_VAR_NAME = '--header-height';
  let rafId = null;

  function updateHeaderHeight() {
    const header = document.querySelector('header-component');
    if (!header) return;

    const height = header.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
      CSS_VAR_NAME,
      `${Math.round(height)}px`
    );
  }

  function requestUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateHeaderHeight();
    });
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', requestUpdate);
  window.addEventListener('load', requestUpdate);

  // Responsive updates
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('orientationchange', requestUpdate);

  // Font loading can change header height
  if (document.fonts) {
    document.fonts.ready.then(requestUpdate);
  }

  // Optional: observe header internal changes (menus opening, announcements, etc.)
  const observer = new MutationObserver(requestUpdate);

  const header = document.querySelector('header-component');
  if (header) {
    observer.observe(header, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }
})();



/*------------------ end of READ THE VALUE OF HEADER-COMPONENT TO USE IN CSS VARIABLES *--------------------*/




/*-----------------------------
* GSAP ANIMATION REVEAL ON SCROLL
*---------------------------*/

import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// ----------------------------------------------------------------------
// 🌿  REVEAL-ON-SCROLL ELEMENTS (FOUC-safe)
// ----------------------------------------------------------------------
function initRevealOnScroll() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded');
    return;
  }
  

  const selectors = '.reveal-on-scroll, .reveal-fade, .reveal-slide-up, .reveal-slide-left';
  const revealElements = document.querySelectorAll(selectors);
  if (!revealElements.length) return;

  revealElements.forEach((el) => {
    // Skip if already wired
    if (el.dataset.revealInit === '1') return;
    el.dataset.revealInit = '1';

    // Determine initial/target states
    const isUp    = el.classList.contains('reveal-slide-up');
    const isLeft  = el.classList.contains('reveal-slide-left');
    const from    = { opacity: 0 };
    if (isUp)   from.y = 30;
    if (isLeft) from.x = -30;

    // Delay utility via classes like .delay-100, .delay-200 ... .delay-1000
    let delay = 0;
    for (let i = 0; i <= 1000; i += 100) {
      if (el.classList.contains(`delay-${i}`)) { delay = i / 1000; break; }
    }

    gsap.fromTo(
      el,
      from,
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 0.6,
        delay,
        ease: 'power2.out',
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none none',
          once: true,
        },
      }
    );
  });

  // Stagger groups
  document.querySelectorAll('.stagger-group').forEach((group) => {
    const items = group.querySelectorAll(selectors);
    if (!items.length) return;

    // Guard: mark all as init (so we don't double-wire)
    items.forEach((el) => (el.dataset.revealInit = '1'));

    const tl = gsap.timeline({
      defaults: { ease: 'power2.out', duration: 0.6 },
      scrollTrigger: {
        trigger: group,
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true,
      },
    });

    items.forEach((item, idx) => {
      const from = { opacity: 0 };
      if (item.classList.contains('reveal-slide-up')) from.y = 30;
      if (item.classList.contains('reveal-slide-left')) from.x = -30;
      tl.fromTo(item, from, { opacity: 1, x: 0, y: 0 }, idx * 0.1);
    });
  });
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', initRevealOnScroll);

// Re-init for Shopify editor section loads
document.addEventListener('shopify:section:load', () => {
  setTimeout(initRevealOnScroll, 100);
});

// One final refresh after images/fonts finish -> prevents late layout shifts
window.addEventListener('load', () => {
  ScrollTrigger.refresh();
});


/* END OF GSAP ANIMATION*/




/*right links navigation dropdown*/
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.header-dropdown__trigger');

  function handleMobileLinks() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    triggers.forEach(el => {
      if (isMobile) {
        el.addEventListener('click', preventNav);
      } else {
        el.removeEventListener('click', preventNav);
      }
    });
  }

  function preventNav(e) {
    e.preventDefault();
  }

  handleMobileLinks();
  window.addEventListener('resize', handleMobileLinks);
});

function preventNav(e) {
  e.preventDefault();

  const current = e.currentTarget.closest('.header-dropdown');
  const allDropdowns = document.querySelectorAll('.header-dropdown');

  // Close all others
  allDropdowns.forEach(drop => {
    if (drop !== current) {
      drop.classList.remove('is-open');
    }
  });

  // Toggle current
  current.classList.toggle('is-open');
}